import { useEffect, useState } from 'react';
import { AtmsApiClient, AuthenticatedSession } from '@amzn/et-console-components';
import { User, Vendor } from '../types/commonTypes';
import { stringify } from 'query-string';
import { getAppHostConfig } from '@amzn/et-console-components';

const { WEB_HOST_AND_PORT } = getAppHostConfig();

interface FoundUsers {
  other: User[];
  vendors: Vendor[];
  recent: User[];
  discovered: User[];
}

interface State {
  isLoadingUsers: boolean;
  usersLoadError: string | null;
  foundUsers: FoundUsers;
  usersById: { [id: number]: User };
  vendorsById: { [id: number]: Vendor };
}

export const useUsersAndVendorsForJobAssign = (session?: AuthenticatedSession): State => {
  const [state, setState] = useState<State>({
    isLoadingUsers: true,
    usersLoadError: null,
    foundUsers: { other: [], vendors: [], recent: [], discovered: [] },
    usersById: {},
    vendorsById: {},
  });

  // We use specific properties of the session to trigger reloads.
  // Using the entire 'session' object can cause unnecessary re-renders if the object reference changes frequently.
  const organizationId = session?.organization?.id;
  const userId = session?.user?.id;

  useEffect(() => {
    const query = {
      organizationId, // Add organizationId to the query to prevent browser caching of results from different orgs
      // TODO: Get source locale, target locale, workflow step, and client for additional filtering
      // sourceLocale: getUniqueOrUndefined(jobParts.map(jp => jp.sourceLocale)),
      // targetLocale: getUniqueOrUndefined(jobParts.map(jp => jp.targetLocale)),
      // workflowStep: getUniqueOrUndefined(
      //   jobParts.map(jp => jp.workflowStep && jp.workflowStep.id)
      // ),
      // client: getUniqueOrUndefined(jobParts.map(jp => jp.client && jp.client.id)),
    };
    console.log('[useUsersAndVendorsForJobAssign] request organizationId:', organizationId);

    AtmsApiClient.httpGet(
      `//${WEB_HOST_AND_PORT}/web/api/v9/job/getUsersAndVendorsForJobAssign?${stringify(query)}`
    )
      .then(result => {
        const foundUsers = result as FoundUsers;
        setState({
          isLoadingUsers: false,
          usersLoadError: null,
          foundUsers: foundUsers,
          usersById: [...foundUsers.other, ...foundUsers.recent, ...foundUsers.discovered].reduce(
            (acc, val) => {
              acc[val.id] = val;
              return acc;
            },
            {}
          ),
          vendorsById: foundUsers.vendors.reduce((acc, val) => {
            acc[val.id] = val;
            return acc;
          }, {}),
        });
      })
      .catch(error => {
        console.error('[useUsersAndVendorsForJobAssign] failed to load users/vendors:', error);
        setState({
          isLoadingUsers: false,
          usersLoadError: 'Unable to load users and vendors. Please refresh and try again.',
          foundUsers: { other: [], vendors: [], recent: [], discovered: [] },
          usersById: {},
          vendorsById: {},
        });
      });
  }, [organizationId, userId]);

  return state;
};
